import React from "react";
import { Grid, Typography } from "@mui/material";

const DetailedField = ({ label, value }) => (
  <Grid container item xs={12} sx={{ borderBottom: "1px solid #e0e0e0", py: 1, alignItems: "center" }}>
    <Grid item xs={6}>
      <Typography variant="body2">{label}:</Typography>
    </Grid>
    <Grid item xs={6} sx={{ textAlign: "right" }}>
      <Typography variant="body2" sx={{ wordBreak: "break-word", fontWeight: "bold" }}>
        {value}
      </Typography>
    </Grid>
  </Grid>
);

export default DetailedField;
